import React from 'react';
import { Link } from 'react-router-dom';

const Banner4 = () => {
  const features = [
    {
      icon: (
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      label: 'Performance Analytics',
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      label: 'ROI Optimization',
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
        </svg>
      ),
      label: 'Targeted Campaigns',
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      label: 'Strategic Insights',
    },
  ];

  return (
    <section className="bg-black text-white py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 relative">
        <div className="mx-auto">
          <div className="relative bg-gradient-to-br from-white/5 to-transparent backdrop-blur-sm rounded-3xl p-12 border border-white/10">
            <div className="absolute -inset-px bg-gradient-to-r from-primary/50 via-primary/20 to-transparent opacity-20 blur-xl rounded-3xl" />
            
            <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div className="space-y-8">
                <div>
                  <div className="inline-flex items-center gap-2 bg-primary/20 text-primary px-4 py-2 rounded-full mb-6">
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    <span className="text-sm font-medium">BOOST YOUR SALES</span>
                  </div>

                  <h2 className="text-4xl lg:text-5xl font-bold leading-tight mb-6">
                  Create & Optimize your Amazon PPC with Verified Amazon ads Partner
                  </h2>

                  <p className="text-xl text-white/80">
                  Get your FREE Amazon Seller Central account video audit today and unlock expert strategies to maximize your returns.
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {features.map((feature, index) => (
                    <div key={index} className="flex items-center gap-4 bg-white/5 hover:bg-white/10 rounded-xl p-4 transition-all duration-300 hover:-translate-y-1">
                      <div className="text-primary">
                        {feature.icon}
                      </div>
                      <span className="font-medium">{feature.label}</span>
                    </div>
                  ))}
                </div>

                <div className="flex gap-4 flex-col md:flex-row">
                  <Link to="/contact"><button className="flex-1 bg-primary hover:bg-primary/90 text-black font-bold px-8 py-4 rounded-xl transition-colors duration-300">
                    GET A FREE AUDIT
                  </button></Link>
                  <Link to="/services/ppc-management"><button className="flex-1 bg-white/5 hover:bg-white/10 text-white font-medium px-8 py-4 rounded-xl transition-colors duration-300">
                    Learn More
                  </button></Link>
                </div>
              </div>

              <div className="relative">
                <img src="https://www.trioperspective.com/images/01.png" alt="Banner" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .animate-spin-slow {
          animation: spin-slow 20s linear infinite;
        }
      `}</style>
    </section>
  );
};

export default Banner4;
